import { BrandColors } from "../theme";

export const menuTokens = {
    root:{
        color: BrandColors.semantic.text,
    },
    item: {
         color: BrandColors.semantic.text,
    }
}